import { render, staticRenderFns } from "./ViewList.vue?vue&type=template&id=0f3c11eb&"
import script from "./ViewList.vue?vue&type=script&lang=js&"
export * from "./ViewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports